// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const bellsprout: PokeData = {
  "id": 69,
  "name": "bellsprout",
  "height": 7,
  "weight": 40,
  "base_experience": 60,
  "types": [
    PokeType.GRASS,
    PokeType.POISON
  ],
  "api_moves": [
    "slam",
    "vine-whip",
    "wrap",
    "acid",
    "growth",
    "razor-leaf",
    "poison-powder",
    "stun-spore",
    "sleep-powder",
    "sweet-scent",
    "knock-off",
    "wring-out",
    "gastro-acid",
    "poison-jab",
    "power-whip"
  ],
  "moves": [
    "vine-whip",
    "acid",
    "razor-leaf",
    "poison-powder",
    "stun-spore",
    "poison-jab",
    "power-whip",
    "wood-hammer",
    "bullet-seed",
    "sludge-bomb",
    "aromatherapy",
    "venom-drench",
    "acid-rain"
  ],
  "evolution_chain": {
    "id": 29,
    "item": null,
    "species": [
      {
        "name": "bellsprout",
        "order": 75,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "weepinbell",
        "order": 76,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": 69,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 21,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "victreebel",
        "order": 77,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": 70,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "leaf-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 41.25,
    "speed": 40,
    "ability_power": 75
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
